import { render, staticRenderFns } from "./widget_twin_souls.vue?vue&type=template&id=2e130d54&scoped=true&"
import script from "./widget_twin_souls.vue?vue&type=script&lang=js&"
export * from "./widget_twin_souls.vue?vue&type=script&lang=js&"
import style0 from "./widget_twin_souls.vue?vue&type=style&index=0&id=2e130d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e130d54",
  null
  
)

export default component.exports